import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { UuiDefaultTheme, UuiGlobalVariablesTheme } from '@aonunited/react';
import { BrowserRouter } from 'react-router-dom';
ReactDOM.createRoot(document.getElementById('root')).render(React.createElement(BrowserRouter, null,
    React.createElement(App, null),
    React.createElement(UuiGlobalVariablesTheme, null),
    React.createElement(UuiDefaultTheme, null)));
